<template>
  <router-link :to="{ name: 'resource', params: { id: resource.id} }" v-if="resource">
    <article class="card is-clickable resource-card">
      <div class="card-content is-small">
        <div class="media">
          <div class="media-left">
            <figure class="resource-card-image image">
              <img :src="resource.thumb" :alt="resource.title">
            </figure>
          </div>
          <div class="media-content">
            <h5 class="resource-card-title">{{ resource.title }}</h5>
            <span class="resource-card-tag tag" :class="`is-category-${resource.subjects[0].id}`" v-if="resource.subjects.length > 0">{{ resource.subjects[0].name }}</span>
            <span class="resource-card-tag tag is-category-0" v-if="resource.subjects.length > 1">{{ `${resource.subjects.length - 1}+` }}</span>
            <div class="resource-card-info">
              <p>{{ resource.type.name }}</p>
              <p>
                <span v-for="(grade, index) in resource.grades" :key="index">{{ index === 0 ? '' : ', ' }}{{ grade.name }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </article>
  </router-link>
</template>

<script>
export default {
  props: {
    resource: {
      type: Object,
      required: false
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.resource-card {
  color: $color-text-light;
  position: relative;
}

.resource-card-image {
  width: 7rem;
  height: 7rem;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.resource-card-title {
  margin-bottom: 1rem;
  @include text-size-m();
  font-weight: 600;
  color: $color-text-dark;
}

.resource-card-tag {
  margin-bottom: 1rem;
}

.resource-card-info {
  @include text-size-xs();
  font-weight: 600;
  line-height: 1rem;
  color: #7D8394;
  text-transform: uppercase;
}

</style>



// WEBPACK FOOTER //
// src/components/ResourceThumbnail.vue